/**
 * Smooth scroll utility.
 * Respects `prefers-reduced-motion` and reads the target's
 * `scroll-margin-top` so anchor targets land where CSS says they should.
 */
export function smoothScrollToId(id) {
  const el = typeof id === 'string' ? document.getElementById(id) : id;
  if (!el) return false;

  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const rect = el.getBoundingClientRect();
  const cs = window.getComputedStyle(el);
  const scrollMargin = parseInt(cs.scrollMarginTop || '0', 10) || 0;
  const targetY = Math.max(0, window.scrollY + rect.top - scrollMargin);

  if (prefersReducedMotion) {
    window.scrollTo(0, targetY);
    return true;
  }

  const startY = window.scrollY;
  const distance = targetY - startY;
  if (Math.abs(distance) < 1) return true;

  const duration = 700;
  const start = performance.now();
  const ease = (t) => 1 - Math.pow(1 - t, 3); // ease-out cubic

  const step = (now) => {
    const t = Math.min((now - start) / duration, 1);
    window.scrollTo(0, startY + distance * ease(t));
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
  return true;
}
